import src from "IMAGE";
export default { src, width: 308, height: 83, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AFUNDVhqFxdlZhsbXnAhIWRfFRVaYRQUXVAYGEoVExMYAFAPD0taFxdOZRwcWW8gIGBaFhZOYBYWWYQpKXkvLCw2zDoOFHmBjBwAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 2 }
